import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";
import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput"
import ActionAdd from '../../store/action/FlowTemplate/Add'
import ActionEdit from '../../store/action/DivisionSetting/Edit'
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllDivision from '../../store/action/Division/FetchAll';
import ActionGetAllSender from '../../store/action/Sender/FetchAll';
import Select2Multiple from "../../infra/components/formInput/SelectMultiple";
class Form extends Component {

    constructor(props) {
        super(props);
        this.state = {
            form: fromJS({
                'client-id': '',
                'division-id': '',
                'sender-id': '',
                'category': '',
                'namespace': '',
                'flow-name': ''
            }),
            disabled: false,
            errors: fromJS({}),
            error: '',
            category: [
                {
                    'value': 'SIGN_UP',
                    'label': 'SIGN_UP'
                },
                {
                    'value': 'SIGN_IN',
                    'label': 'SIGN_IN'
                },
                {
                    'value': 'APPOINTMENT_BOOKING',
                    'label': 'APPOINTMENT_BOOKING'
                },
                {
                    'value': 'LEAD_GENERATION',
                    'label': 'LEAD_GENERATION'
                },
                {
                    'value': 'CONTACT_US',
                    'label': 'CONTACT_US'
                },
                {
                    'value': 'CUSTOMER_SUPPORT',
                    'label': 'CUSTOMER_SUPPORT'
                },
                {
                    'value': 'SURVEY',
                    'label': 'SURVEY'
                },
                {
                    'value': 'OTHER',
                    'label': 'OTHER'
                },
            ],
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        this.props.actionGetAllClient();
    }

    handleChange(field, value) {
        var formVal = this.state.form;
        formVal = formVal.set(field, value);

        if (field === 'client-id') {
            this.setState({ client_id: value })
            this.props.actionGetAllDivision(value, 'List Upload');
            this.props.actionGetAllSender(value);
        }

        if (field === 'division-id') {
            formVal = formVal.set('sender-id', '')
            this.setState({ form: formVal })
            this.props.actionGetAllSender(this.state.client_id, value);
        }

        this.setState({ form: formVal })
    }
    handleChangeSelect = selectedOption => {
        var formVal = this.state.form;
        formVal = formVal.set('category', selectedOption);
        this.setState({ form: formVal });
    }
    async handleSubmit(dispatch) {

        const form = this.state.form;

        if (form.get('client-id') == '' || form.get('client-id') == null || form.get('client-id') == undefined) {
            this.setState({ error: "Client cannot be empty!" });
            toast.error('Clienat cannot be empty!', toast.POSITION.TOP_RIGHT);

            return false;
        }

        if (form.get('division-id') == '' || form.get('division-id') == null || form.get('division-id') == undefined) {
            this.setState({ error: "Division cannot be empty!" });
            toast.error('Division cannot be empty!', toast.POSITION.TOP_RIGHT);

            return false;
        }

        if (form.get('sender-id') == '' || form.get('sender-id') == null || form.get('sender-id') == undefined) {
            this.setState({ error: "Sender cannot be empty!" });
            toast.error('Sender cannot be empty!', toast.POSITION.TOP_RIGHT);

            return false;
        }

        if (form.get('category') == '' || form.get('category') == null || form.get('category') == undefined) {
            this.setState({ error: "Category cannot be empty!" });
            toast.error('Category cannot be empty!', toast.POSITION.TOP_RIGHT);

            return false;
        }

        if (form.get('namespace') == '' || form.get('namespace') == null || form.get('namespace') == undefined) {
            this.setState({ error: "Namespace cannot be empty!" });
            toast.error('Namespace cannot be empty!', toast.POSITION.TOP_RIGHT);

            return false;
        }

        if (form.get('flow-name') == '' || form.get('flow-name') == null || form.get('flow-name') == undefined) {
            this.setState({ error: "Flow Name cannot be empty!" });
            toast.error('Flow Name cannot be empty!', toast.POSITION.TOP_RIGHT);

            return false;
        }

        switch (this.props.actionType) {
            case IsCreate:
                await this.SubmitNewData();
                break;
            case IsEdit:
                await this.SubmitEditData();
                break;
            default:
            // code block
        }


    }

    async SubmitNewData() {
        const form = this.state.form;
        var dataCategory = form.get('category').map((item) => item.value);
        var data ={
                'client_id': form.get('client-id'),
                'division_id': form.get('division-id'),
                'sender': form.get('sender-id'),
                'categories': dataCategory,
                'namespace': form.get('namespace'),
                'name': form.get('flow-name'),

            };

        var response = await this.props.actionAdd(data);
        if (response.ok) {
            toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
            this.props.handleCancelForm(true);
        } else {
            toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
        }
    }

    async SubmitEditData() {
        const form = this.state.form;
        var data =
        {
            'data':
            {
                'client-id': form.get('client-id'),
                'division-name': form.get('division-name'),
                'division-id':form.get('division-id')
            }
        };

        var response = await this.props.actionEdit(data);
        if (response.ok) {
            toast.success('Edit Success!', toast.POSITION.TOP_RIGHT);
            this.props.handleCancelForm(true);
        } else {
            toast.error('Edit Failed', toast.POSITION.TOP_RIGHT);
        }
    }

    handleCancel() {
        this.props.handleCancelForm(false);
    }

    componentWillMount() {
        if (this.props.item != null || this.props.item !== undefined) {
            if ((this.props.actionType === IsView || this.props.actionType === IsEdit) && !this.state.loadded) {
                this.setState({
                    form: fromJS({
                        'client-id': this.props.item.get('client-id'),
                        'division-name': this.props.item.get('division-name'),
                        'division-id':this.props.item.get('division-id')
                    }),
                    loadded: true,
                    disabled: (this.props.actionType === IsView),
                })
            }
        }
    }

    render() {
        const { form, errors, disabled } = this.state;
        return (
            <div className="card no-margin-bottom">
                <div className="body">
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Client</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='client-id'
                                value={form.get('client-id')}
                                options={fromJS({
                                    'source': this.props.clientall,
                                    'value': 'client-id',
                                    'label': 'client-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Client"
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Division</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='division-id'
                                value={form.get('division-id')}
                                options={fromJS({
                                    'source': this.props.divisionall,
                                    'value': 'division-id',
                                    'label': 'division-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Division"
                                disabled={this.state.disrest}
                                // disabled={this.state.disabled}
                                hasError={errors.has('division-id')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Sender</span>
                        <div className="col-sm-10">
                            <ComboboxInput
                                field='sender-id'
                                value={form.get('sender-id')}
                                options={fromJS({
                                    'source': this.props.senderall,
                                    'value': 'sender-id',
                                    'label': 'sender-name'
                                })}
                                onChange={(field, value, label) => this.handleChange(field, value, label)}
                                placeholder="Sender"
                                disabled={this.state.disrest}
                                // disabled={this.state.disabled}
                                hasError={errors.has('sender-id')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Category</span>
                        <div className="col-sm-10">
                            <Select2Multiple
                                value={form.get('prefix')}
                                onChange={this.handleChangeSelect}
                                options={this.state.category}
                                placeholder="Category"
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Name Space</span>
                        <div className="col-sm-10">
                            <TextInputField
                                className="form-control"
                                field={'namespace'}
                                value={form.get('namespace')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="Name Space"
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Flow Name</span>
                        <div className="col-sm-10">
                            <TextInputField
                                className="form-control"
                                field={'flow-name'}
                                value={form.get('flow-name')}
                                onChange={(field, value) => this.handleChange(field, value)}
                                placeholder="Flow Name"
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2"></span>
                        <div className="col-sm-10">
                            <button type="button"
                                className="btn btn-wide btn-danger"
                                value="Cancel"
                                onClick={this.handleCancel}>
                                Cancel
                            </button>
                            <button type="button"
                                className="btn btn-wide btn-success"
                                onClick={this.handleSubmit}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
        }
    },
    dispatch => bindActionCreators({
        actionAdd: ActionAdd,
        actionGetAllClient: ActionGetAllClient,
        actionGetAllDivision: ActionGetAllDivision,
        actionGetAllSender: ActionGetAllSender,
        actionEdit: ActionEdit,

    }, dispatch),
)(Form);